import React from 'react'

import strings from '../../../strings'
import { percentComplete } from '../functions'
import { useProjectDownload } from '../useDownload'

import './offlineProgressBar.less'

/**
 * A slim bar reporting the project's offline pre-download. Non-blocking by design: the visitor browses
 * while it fills, and it disappears when the download finishes rather than announcing that it did — no
 * one asked for it, so it has nothing to celebrate.
 */
const OfflineProgressBar: React.FC = () => {
	const download = useProjectDownload()
	if (!download || download.progress.total === 0) return null

	const percent = percentComplete(download.progress)
	const label = strings.formatString(strings.downloading_content, {
		completed: download.progress.done,
		total: download.progress.total,
	}) as string

	return (
		<div
			className="offline-progress"
			role="progressbar"
			aria-label={label}
			aria-valuemin={0}
			aria-valuemax={100}
			aria-valuenow={percent}
		>
			<div className="offline-progress-fill" style={{ width: `${percent}%` }} />
		</div>
	)
}

export default OfflineProgressBar
